import api from "../api"
import { auth, doctors, hospitals } from "../api_endpoints"


export const checkByAadhaar=async(data)=>{
    const aadhaar_id=data

    try {
        const response=await api.post(auth.checkUserByAdhaar,{aadhaar_id})
        return response.response
    } catch (error) {
        throw error.response
    }
}

export const sendOtp=async(data)=>{
    const mobile=data

    try {
        const response=await api.post(auth.sendOtp,{mobile,requester:"Dignostic"})
        return response
    } catch (error) {
        throw error
    }
}

export const loginDiagnostic=async(data)=>{
    const {mobile,aadhaar_id,device_token,otp}=data

    try {
        const response=await api.post(auth.loginDoctor,{mobile,aadhaar_id,device_token,otp})
        return response
    } catch (error) {
        throw error
    }
}

export const createDiagnostic=async(data)=>{
    const {first_name,last_name,aadhaar_id,email,gender,profile_image,primary_number,dob,license_number,hospital_name,address}=data
    const formData = new FormData()
    formData.append("first_name", first_name);
    formData.append("last_name", last_name);
    formData.append("aadhaar_id", aadhaar_id);
    formData.append("email", email);
    formData.append("gender", gender);
    formData.append("profile_image", profile_image);
    formData.append("primary_number", primary_number);
    formData.append("dob", dob);
    formData.append("license_number", license_number);
    formData.append("hospital_name", hospital_name);
    formData.append("address", address);

    try {
        const response=await api.post(auth.createDoctor,formData,{
             headers: {
          "Content-Type": "multipart/form-data",
        },
        })
        return response
    } catch (error) {
        throw error
    }
}

export const sendRequestDoctor=async(token,data)=>{
    try {
         const response=await api.post(doctors.requestDoctor,data,{
             headers: {
          "Content-Type": "application/json",
          "Authorization":`Bearer ${token}`
        },
        })
        return response
    } catch (error) {
        console.log(error);
        
    }

}

export const getAllDoctor=async(token)=>{
    try {
         const response=await api.get(doctors.getAllDoctors,{
             headers: {
          "Content-Type": "multipart/form-data",
          "Authorization":`Bearer ${token}`
        },
        })
        return response
    } catch (error) {
        console.log(error);
        
    }

}


export const getAllRequestsfromDoctor=async(token)=>{
    try {
         const response=await api.get(doctors.requestFromdoctors,{
             headers: {
          "Content-Type": "multipart/form-data",
          "Authorization":`Bearer ${token}`
        },
        })
        return response
    } catch (error) {
        console.log(error);
        
    }

}

export const getAllRequestsfromHospital=async(token)=>{
    try {
         const response=await api.get(hospitals.requestsFromHospitals,{
             headers: {
          "Content-Type": "multipart/form-data",
          "Authorization":`Bearer ${token}`
        },
        })
        return response
    } catch (error) {
        console.log(error);
        
    }

}


export const getAllHospitals=async(token)=>{
    try {
         const response=await api.get(hospitals.getAllHospitals,{
             headers: {
          "Content-Type": "multipart/form-data",
          "Authorization":`Bearer ${token}`
        },
        })
        return response
    } catch (error) {
        console.log(error);
        
    }

}